// :: TranspilationOptions
export const LIVENESS = {
  NONE: 'NONE',
  DEBUG: 'DEBUG',
  SIMULATION: 'SIMULATION',
};

export default {};
